function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "sinqa",
  d: "M1003.071 3251.927c-1.19-.054-1.835-.252-2.265-.42a3.79 3.79 0 0 1-1.403-.911 3.76 3.76 0 0 1-.912-1.403c-.168-.43-.366-1.075-.42-2.265-.06-1.285-.071-1.67-.071-4.928 0-3.257.013-3.642.07-4.929.055-1.19.254-1.834.42-2.265.222-.57.487-.975.913-1.403a3.766 3.766 0 0 1 1.402-.913c.43-.167 1.076-.365 2.265-.42 1.287-.058 1.673-.07 4.929-.07 3.257 0 3.642.013 4.929.07 1.19.055 1.834.254 2.265.42.57.22.975.486 1.403.913.427.426.69.833.912 1.402.167.43.365 1.076.42 2.265.058 1.287.07 1.672.07 4.93 0 3.255-.012 3.642-.07 4.928-.055 1.19-.254 1.836-.42 2.265-.222.57-.486.976-.912 1.403-.427.426-.834.69-1.403.912-.43.167-1.076.365-2.265.42-1.286.058-1.672.07-4.93.07-3.255 0-3.641-.011-4.927-.07"
}), React.createElement("path", {
  id: "sinqc",
  d: "M1004.957 3234.655c.792-.037 1.046-.045 3.063-.045 2.018 0 2.27.009 3.063.045.79.035 1.33.161 1.803.345.488.19.903.444 1.316.857.413.414.667.828.857 1.316.183.472.309 1.012.345 1.803.036.793.044 1.046.044 3.063 0 2.018-.008 2.27-.044 3.063-.036.791-.162 1.331-.345 1.804a3.64 3.64 0 0 1-.857 1.316 3.654 3.654 0 0 1-1.316.857c-.473.183-1.013.309-1.804.345-.792.036-1.045.045-3.063.045-2.017 0-2.27-.01-3.063-.045-.79-.036-1.33-.162-1.803-.345a3.65 3.65 0 0 1-1.316-.857 3.632 3.632 0 0 1-.857-1.316c-.184-.473-.309-1.013-.345-1.804-.037-.792-.045-1.045-.045-3.063 0-2.017.008-2.27.045-3.063.036-.79.161-1.33.345-1.803.19-.489.444-.903.857-1.316a3.647 3.647 0 0 1 1.316-.857c.472-.184 1.013-.309 1.803-.345m.062 13.432c.783.036 1.017.043 3.001.043s2.22-.007 3.003-.043c.724-.033 1.118-.154 1.38-.256a2.31 2.31 0 0 0 .854-.555c.26-.26.42-.507.556-.854.101-.262.222-.656.255-1.38.036-.784.044-1.018.044-3.002 0-1.984-.008-2.219-.044-3.003-.033-.724-.153-1.118-.255-1.38a2.302 2.302 0 0 0-.556-.854 2.302 2.302 0 0 0-.855-.556c-.262-.1-.655-.222-1.38-.255-.783-.036-1.018-.044-3.002-.044-1.983 0-2.218.008-3.001.044-.724.033-1.118.153-1.38.255a2.29 2.29 0 0 0-.854.556c-.26.26-.421.508-.556.854-.101.263-.223.656-.256 1.38-.035.784-.043 1.019-.043 3.003 0 1.984.007 2.219.043 3.002.033.724.154 1.118.256 1.38.134.346.295.594.556.854.26.26.507.42.854.555.262.102.656.223 1.38.256m6.076-10.009a.897.897 0 1 1 0 0m-6.89 3.961a3.815 3.815 0 1 1 7.63 0 3.815 3.815 0 0 1-7.63 0m1.34.005a2.481 2.481 0 1 0 4.962.001 2.481 2.481 0 0 0-4.963 0"
}), React.createElement("radialGradient", {
  id: "sinqb",
  cx: 999.29,
  cy: 3251.56,
  r: 25.39,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0.09,
  stopColor: "#fa8f21"
}), React.createElement("stop", {
  offset: 0.78,
  stopColor: "#d82d7e"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", {
  transform: "translate(-998 -3232)"
}, React.createElement("use", {
  fill: "url(#sinqb)",
  xlinkHref: "#sinqa"
})), React.createElement("g", {
  transform: "translate(-998 -3232)"
}, React.createElement("use", {
  fill: "#fff",
  xlinkHref: "#sinqc"
})));

var SvgInstagram = function SvgInstagram(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgInstagram, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/instagram.06bbd7b7.svg";
export { ForwardRef as ReactComponent };